import { getOrganizationHelpers } from '@sravni/ugc/lib/organizations/helpers';

import { QUERY_NAMES, TCreateReviewPageQuery } from '../../../types/router';
import { REVIEW_FIELDS } from '../constants/common';
import { TFormInputs } from '../types';

export const checkStoredReviewMatchingQuery = (
  query: TCreateReviewPageQuery,
  storedReview?: Partial<TFormInputs>,
): boolean => {
  const {
    [QUERY_NAMES.TYPE]: orgTypeQuery,
    [QUERY_NAMES.REVIEW_OBJECT_ID]: orgIdQuery,
    [QUERY_NAMES.ORGANIZATION]: orgId2Query,
    [QUERY_NAMES.REGION_ID]: locationIdQuery,
    [QUERY_NAMES.TAG]: serviceQuery,
    [QUERY_NAMES.SPECIFIC_PRODUCT]: productIdQuery,
    // блок о юзере
    [QUERY_NAMES.BIRTHDATE]: birthdayQuery,
    [QUERY_NAMES.NAME]: nameQuery,
    [QUERY_NAMES.PHONE]: phoneQuery,
  } = query;

  const {
    [REVIEW_FIELDS.ORGANIZATION_TYPE]: orgTypeStoredReview,
    [REVIEW_FIELDS.ORGANIZATION_ID]: orgIdStoredReview,
    [REVIEW_FIELDS.SERVICE]: serviceStoredReview,
    [REVIEW_FIELDS.LOCATION_GAR_ID]: locationGarIdStoredReview,
    [REVIEW_FIELDS.PRODUCT_ID]: productIdStoredReview,
    // блок о юзере
    [REVIEW_FIELDS.BIRTHDAY]: birthdayStoredReview,
    [REVIEW_FIELDS.USER_NAME]: nameStoredReview,
    [REVIEW_FIELDS.USER_PHONE]: phoneStoredReview,
  } = storedReview ?? {};

  const orgHelperQuery = getOrganizationHelpers(orgTypeQuery);

  const isOrgTypeNotMatching =
    orgTypeQuery && orgTypeStoredReview && orgHelperQuery.typeForService !== orgTypeStoredReview;

  const isOrgIdNotMatching =
    (orgIdQuery && orgIdStoredReview && orgIdQuery !== orgIdStoredReview) ||
    (orgId2Query && orgIdStoredReview && orgId2Query !== orgIdStoredReview);

  const isLocationNotMatching =
    locationIdQuery && locationGarIdStoredReview && Number(locationIdQuery) !== locationGarIdStoredReview;

  const isServiceNotMatching = serviceQuery && serviceStoredReview && serviceQuery !== serviceStoredReview;

  const isProductIdNotMatching =
    serviceQuery &&
    serviceStoredReview &&
    serviceQuery === serviceStoredReview &&
    productIdQuery &&
    productIdStoredReview &&
    productIdQuery !== productIdStoredReview;

  const isBirthdayNotMatching = birthdayQuery && birthdayStoredReview && birthdayQuery !== birthdayStoredReview;

  const isNameNotMatching = nameQuery && nameStoredReview && nameQuery !== nameStoredReview;

  const isPhoneNotMatching = phoneQuery && phoneStoredReview && phoneQuery !== phoneStoredReview;

  const isNotMatching =
    isOrgTypeNotMatching ||
    isOrgIdNotMatching ||
    isLocationNotMatching ||
    isServiceNotMatching ||
    isProductIdNotMatching ||
    isBirthdayNotMatching ||
    isNameNotMatching ||
    isPhoneNotMatching;

  return !isNotMatching;
};
